import { useEffect, useRef, useState } from 'react';
const order = ['Cmd', 'Alt', 'Ctrl', 'Shift'];
const keyByPlatform = /Mac/i.test(navigator.userAgent) ? 'Cmd' : 'Ctrl';
const normalize = (shortcut) => shortcut
    .split('+')
    .map((key) => (key === 'CtrlOrCmd' ? keyByPlatform : key))
    .sort((a, b) => order.indexOf(b) - order.indexOf(a))
    .join('+')
    .toLowerCase();
const trigger = (shortcut) => {
    const normalized = normalize(shortcut);
    const keys = normalized
        .replace('cmd', '')
        .replace('ctrl', '')
        .replace('alt', '')
        .replace('shift', '')
        .split('+');
    const eventOptions = {};
    if (normalized.includes('cmd'))
        eventOptions.metaKey = true;
    if (normalized.includes('ctrl'))
        eventOptions.ctrlKey = true;
    keys.filter(Boolean).forEach((key) => {
        window.dispatchEvent(new KeyboardEvent('keydown', Object.assign({ key }, eventOptions)));
    });
};
export const useShortcuts = (value) => {
    const [shortcuts, setShortcuts] = useState({});
    const keyMapping = useRef();
    useEffect(() => {
        setShortcuts(Object.keys(value).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [normalize(key)]: value[key] })), {}));
    }, [value]);
    useEffect(() => {
        if (!navigator.keyboard)
            return;
        navigator.keyboard
            .getLayoutMap()
            .then((layout) => {
            keyMapping.current = Array.from(layout).reduce((result, [keyCode, keyValue]) => (Object.assign(Object.assign({}, result), { [keyCode]: keyValue })), {});
        })
            .catch((err) => {
            console.log(err);
        });
    }, []);
    useEffect(() => {
        const handleKeyDown = (event) => {
            var _a, _b;
            const key = (_b = (_a = keyMapping.current) === null || _a === void 0 ? void 0 : _a[event.code]) !== null && _b !== void 0 ? _b : event.key;
            let shortcut = `+${key}`;
            if (event.metaKey)
                shortcut = `,Cmd${shortcut.replace('+Meta', '')}`;
            if (event.altKey)
                shortcut = `,Alt${shortcut.replace('+Alt', '')}`;
            if (event.shiftKey)
                shortcut = `,Shift${shortcut.replace('+Shift', '')}`;
            if (event.ctrlKey)
                shortcut = `,Ctrl${shortcut.replace('+Control', '')}`;
            shortcut = shortcut.startsWith('+') ? shortcut.slice(1) : shortcut;
            shortcut = shortcut.startsWith(',') ? shortcut.slice(1) : shortcut;
            shortcut = shortcut.replace(',', '+');
            const normalized = normalize(shortcut);
            const handler = shortcuts[normalized];
            if (handler) {
                handler(event);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [shortcuts]);
    return { trigger };
};
//# sourceMappingURL=useShortcuts.js.map